<template>
  <div class="d-flex flex-column align-items-center change-password">
    <TextBlock
      :size="1.5"
      class="change-password_title"
      :text="$t('_web_change-password_title', 'Change password')"
    />
    <TextInput
      id="new-password"
      v-model="newPassword"
      v-validate="$options.passwordValidationRule"
      type="password"
      class="w-100 mb-4"
      :label="$t('_web_change-password_new-password', 'New password')"
      name="new-password"
      :error="errors.first('new-password')"
      :data-vv-as="$t('_web_change-password_password', 'password')"
      required
      autocomplete="new-password"
    />
    <TextInput
      id="new-password-repeat"
      v-model="newPasswordRepeat"
      type="password"
      class="w-100 mb-5"
      :label="$t('_web_change-password_repeat-password', 'Repeat password')"
      :error="newPasswordRepeatError"
      required
      autocomplete="new-password"
    />
    <Btn
      :label="$t('_web_change-password_change-password', 'Change Password')"
      :loading="isLoading"
      class="btn-primary w-50"
      :disabled="!isBtnActive"
      @click.native="changePassword"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { password as passwordValidationRule } from '@/constants/validationRules';

import isLoadingMixin from '@/mixins/isLoading';

import TextBlock from '@/components/atoms/TextBlock';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import Btn from '@/components/form/HeraFormSubmitBtn';

export default {
  components: {
    TextBlock,
    TextInput,
    Btn,
  },

  mixins: [isLoadingMixin],

  inject: ['$validator'],

  data() {
    return {
      newPassword: null,
      newPasswordRepeat: null,
    };
  },

  computed: {
    isBtnActive() {
      return (
        this.newPassword &&
        this.newPasswordRepeat &&
        this.newPassword === this.newPasswordRepeat
      );
    },

    newPasswordRepeatError() {
      return this.newPasswordRepeat === this.newPassword
        ? null
        : this.$t(
            '_web_change-password_passwords-must-be-equal',
            'Passwords must be equal.'
          );
    },
  },

  created() {
    this.$options.passwordValidationRule = passwordValidationRule;
  },

  methods: {
    ...mapActions(['submitPass', 'errorNotify', 'successNotify']),

    changePassword() {
      this.setLoading();
      this.$validator
        .validateAll()
        .then(isValid => {
          if (isValid) {
            return this.submitPass({ password: this.newPassword });
          } else {
            throw { silent: true };
          }
        })
        .then(() => {
          this.$router.replace(-1);
          this.successNotify(
            this.$t(
              '_web_change-password_success-notify',
              'Password successfully changed.'
            )
          );
        })
        .catch(this.errorNotify)
        .finally(this.unsetLoading);
    },
  },
};
</script>

<style lang="scss">
.change-password {
  max-width: 22rem;
  margin: auto;
  padding: 2.5rem 3rem 1.25rem 3rem;
  border-radius: 0.25rem;
  background-color: $ph-card;

  &_title {
    margin-bottom: 1.875rem;
  }
}
</style>
